/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Spell Checker Suggestion
 * @export
 * @interface SpellingSuggestion
 */
export interface SpellingSuggestion {
    /**
     * Spelling suggestion
     * @type {string}
     * @memberof SpellingSuggestion
     */
    suggestion?: string;
    /**
     * Query for spelling suggestion
     * @type {string}
     * @memberof SpellingSuggestion
     */
    query?: string;
}

/**
 * Check if a given object implements the SpellingSuggestion interface.
 */
export function instanceOfSpellingSuggestion(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SpellingSuggestionFromJSON(json: any): SpellingSuggestion {
    return SpellingSuggestionFromJSONTyped(json, false);
}

export function SpellingSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpellingSuggestion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'suggestion': !exists(json, 'suggestion') ? undefined : json['suggestion'],
        'query': !exists(json, 'query') ? undefined : json['query'],
    };
}

export function SpellingSuggestionToJSON(value?: SpellingSuggestion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'suggestion': value.suggestion,
        'query': value.query,
    };
}

